import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';
import MasterDataQuery from '../masterData/MasterDataQuery.services';
const GetSectionData = (data: any) =>
    request({
        url: ApiURL.Query.GetSectionData,
        method: RequestType.POST,
        data: data,
    });
const GetAllSectionSummaryList = (data: any) =>
    request({
        url: ApiURL.Query.GetAllSectionSummaryList,
        method: RequestType.GET,
        data: data,
    });
const GetTemplatesData = (data: any) =>
    request({
        url: ApiURL.Query.GetTemplatesData,
        method: RequestType.POST,
        data: data,
    });
const GetSingleSectionData = (data: any) =>
    request({
        url: ApiURL.Query.GetSingleSectionData + data,
        method: RequestType.GET,
    });
const GetTemplatePreview = (data: any) =>
    request({
        url: ApiURL.Query.GetTemplatePreview,
        method: RequestType.POST,
        data: data,
    });
const SendTestMail = (data: any) =>
    request({
        url: ApiURL.Query.SendTestMail,
        method: RequestType.POST,
        data: data,
    });

const GetCountryList = () => MasterDataQuery.GetCountryList();

const EmailTemplateBuilderServiceQuery = {
    GetSectionData,
    GetAllSectionSummaryList,
    GetSingleSectionData,
    GetTemplatesData,
    GetTemplatePreview,
    SendTestMail,
    GetCountryList,
};
export default EmailTemplateBuilderServiceQuery;
